import type { TMessages } from '@/types/TMessages'

export const messages = {
  articlesHeader: 'Новости',
  reactHelmetTitle: 'Новости по рубрике «{rubricName}»',
  mainRubric: 'Главное',
  fieldEvaluationReportDialog: {
    comment: 'Заявка на отчет из Журнала',
  },
} satisfies TMessages
